import { Grid, IconButton, InputAdornment } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import _ from "lodash";
import { useEffect, useState } from "react";
import { ArrayInput, AutocompleteInput, BooleanInput, FormDataConsumer, maxValue, minValue, NumberInput, ReferenceInput, required, SelectInput, SimpleFormIterator, TextInput, useDataProvider, useRecordContext } from "react-admin";
import { useForm } from "react-final-form";
import { SeoDescriptionInput } from "../../component/seo-description-text-input";
import { OnChange } from "react-final-form-listeners";
import { PlatformWithOrderCheckboxGroupInput, platformDefaultValue, platformWithOrderDefaultValue } from "../../component/platform-components";
import { enableMpmPlatformOrdering } from "../../../constant";
import { RegionCheckboxGroupInput, regionDefaultValue } from "../../component/region-components";
import { RowPathInput } from "../../page-row-paths/components/row-path-input";
import { CategoryListForm } from "./category-list-form";
import { EpisodeForm } from "./episode-form";
import { ScoopPlusForm } from "./scoop-plus-form";
import { ShelfDateTimeInput } from "./shelf-date-time-input";
import { TemplateSelectInput } from "./template-select-input";

export const MpmRowFormContent = (props) => {
  const form = useForm();
  const [type, setType] = useState(props.record.type);

  const page = props.page ? props.page : props.record.page ? props.record.page : null;

  useEffect(() => {
    form.change("programme_id", props.record.ref_x);
    // form.change('title_tc', props.record.ref_x);
    // form.change('programme_id', props.record.ref_x);

    if (props.mode == "create" && _.isEmpty(props.record)) {
      //set default value
      form.change(enableMpmPlatformOrdering ? "platform_with_order" : "platform", enableMpmPlatformOrdering ? platformWithOrderDefaultValue : platformDefaultValue);
      form.change("region", regionDefaultValue);
    } else if (props.mode == "edit") {
      form.change(enableMpmPlatformOrdering ? "platform_with_order" : "platform", enableMpmPlatformOrdering ? props.record.platform_with_order : props.record.platform);
    }
  }, []);

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <TextInput label="Name" source="name" validate={required()} fullWidth />
      </Grid>
      <Grid item sm={12} md={12}>
        <SelectInput
          label="Content"
          source="type"
          choices={[
            { id: "category_list", name: "Category List" },
            { id: "editorial_pick", name: "Editorial" },
            { id: "episode_list", name: "Episode" },
            { id: "event", name: "Event" },
            { id: "history", name: "Watching History" },
            { id: "latest", name: "Latest" },
            { id: "programme_list", name: "Programme List" },
            { id: "recommendation", name: "Recommendation" },
            { id: "top_sv", name: "Top SV" },
            { id: "scoopplus", name: "Scoop Plus" },
            { id: "scoopplus_short", name: "Scoop Plus Shorts" },
          ]}
          defaultValue=""
          fullWidth
        />
      </Grid>

      <OnChange name="type">
        {(value, previous) => {
          setType(value);

          //No change OR no previous value, do nothing
          if (!previous || previous === value) {
            return;
          }

          // form.resetField("template_1");
          // form.resetField("template_2");
          // form.resetField("template_3");
          form.change("ref_x", undefined);
          form.change("template", undefined);
          form.change("template_1", undefined);
          form.change("template_2", undefined);
          form.change("template_3", undefined);
        }}
      </OnChange>

      {type == "editorial_pick" ? <FormDataConsumer>{({ formData, ...rest }) => <EditorialForm formData={formData} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "recommendation" ? <FormDataConsumer>{({ formData, ...rest }) => <RecommendationForm formData={formData} page={props.page} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "programme_list" ? <FormDataConsumer>{({ formData, ...rest }) => <ProgrammeListForm formData={formData} rest={rest} mode={props.mode} page={page} />}</FormDataConsumer> : <></>}
      {type == "history" ? <FormDataConsumer>{({ formData, ...rest }) => <WatchingHistoryForm formData={formData} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "latest" ? <FormDataConsumer>{({ formData, ...rest }) => <LatestForm formData={formData} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "top_sv" ? <FormDataConsumer>{({ formData, ...rest }) => <TopSVForm formData={formData} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "episode_list" ? <FormDataConsumer>{({ formData, ...rest }) => <EpisodeForm formData={formData} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "event" ? <FormDataConsumer>{({ formData, ...rest }) => <EventForm formData={formData} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "category_list" ? <FormDataConsumer>{({ formData, ...rest }) => <CategoryListForm formData={formData} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "scoopplus" ? <FormDataConsumer>{({ formData, ...rest }) => <ScoopPlusForm formData={formData} rest={rest} />}</FormDataConsumer> : <></>}
      {type == "scoopplus_short" ? <FormDataConsumer>{({ formData, ...rest }) => <ScoopPlusShortsForm formData={formData} rest={rest} mode={props.mode} page={page} />}</FormDataConsumer> : <></>}
    </Grid>
  );
};

const AutoCompleteEditorial = () => {
  const form = useForm();
  return (
    <ReferenceInput
      label="Search Editorial Name"
      source="editorial_type_autocomplete"
      reference="editorials-autocomplete"
      onChange={(val) => {
        //Reset all params
        // form.change("episode_id", undefined);
        // form.change("content_id", undefined);
        // form.change("caption_tc", undefined);
        // form.change("caption_en", undefined);
        // form.change("programme_name_tc", undefined);
        // form.change("programme_name_en", undefined);
        // form.change("landscape_poster", undefined);
        // form.change("portrait_poster", undefined);
        form.change("programme_id", val);
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name" optionValue="id" fullWidth />
    </ReferenceInput>
  );
};

export const ScoopPlusShortsForm = ({ formData, mode, page, rest }) => {
  const dataProvider = useDataProvider();
  const [channels, setChannels] = useState();
  const form = useForm();

  const handleRemove = () => {
    form.change("channel_id", null);
    form.change("channel_name", null);
  };

  useEffect(() => {
    //Assign ref_x to channel_id for easily understanding
    formData.channel_id = formData.ref_x;

    dataProvider.getList("scoopplus-shorts-channel").then(({ data }) => {
      setChannels(data);

      //Set inital value
      if (formData.channel_id) {
        const c = data.find((c) => c.id == formData.channel_id);
        if (c) {
          form.change("channel_id", c.id);
          form.change("channel_name", c.name);
        }
      }
    });
  }, []);

  var channels_choices = [];

  if (channels) {
    channels_choices = channels.map((channel) => ({
      id: channel.id,
      name: channel.name,
      // name: `${channel.name} - ${channel.id}`,
    }));
  }

  const OptionRenderer = (choice) => {
    if (choice?.record?.id) {
      return `${choice.record.name} - ${choice.record.id}`;
    }
    return "";
  };

  const inputText = (choice) => choice.name;

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <AutocompleteInput //
          label="Search Channel Name / Parent Channel Name"
          source="channel_id"
          choices={channels_choices}
          optionText={<OptionRenderer />}
          inputText={inputText}
          matchSuggestion={(filterValue, suggestion) => (suggestion.name && suggestion.name.toLowerCase().includes(filterValue.toLowerCase())) || (suggestion.id && suggestion.id.toString().includes(filterValue))}
          // optionText="name"
          optionValue="id"
          fullWidth
          allowEmpty
          options={{
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleRemove} edge="end" style={{ color: "red" }}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          onChange={(val) => {
            form.change("channel_id", val);
            form.change("channel_name", val ? channels.find((c) => c.id == val).name : null);
          }}
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Name" source="channel_name" disabled fullWidth />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Channel ID" source="channel_id" disabled fullWidth />
      </Grid>

      {/* <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>
      </Grid> */}

      <Grid item sm={12} md={6}>
        <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
      </Grid>

      <RowPathInput disabled={mode == "edit"} page={page ? page : null} />

      <Grid item sm={12} md={12}>
        <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
      </Grid>
      <Grid item sm={12} md={12}>
        <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
      </Grid>

      <Grid item sm={12} md={12}>
        <TemplateSelectInput layouts={["scoopplus_short"]} isRequired={true} />
      </Grid>

      <Grid item sm={12} md={12}>
        <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
      </Grid>

      <Grid item sm={12} md={12}>
        <RegionCheckboxGroupInput fullWidth />
      </Grid>

      <ShelfDateTimeInput />
    </Grid>
  );
};

export const EditorialForm = ({ formData, rest }) => {
  return (
    <Grid container spacing={1} fullWidth>
      {/* <FetchEditorialData {...formData} editorial_type={formData.editorial_type_autocomplete ?? formData.ref_x.split("/")[1]} /> */}
      <FetchEditorialData {...formData} />

      <Grid item sm={12} md={12}>
        <AutoCompleteEditorial clearAlwaysVisible={true} fullWidth {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Name" source="editorial_name" disabled fullWidth />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Editorial ID" source="editorial_type" disabled validate={required()} fullWidth />
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>
      </Grid>

      <Grid item sm={12} md={12}>
        <TemplateSelectInput layouts={["loop", "loop_med", "loop_small", "multiline", "top_banner", "ranking", "loop_portrait_to_landscape"]} multilineNumOfColumns={[4, 5]} defaultValue={"loop"} isRequired={true} />
      </Grid>

      <Grid item sm={12} md={12}>
        <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
      </Grid>
      <Grid item sm={12} md={12}>
        <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
      </Grid>

      <Grid item sm={12} md={12}>
        <TextInput label="Page title in TC (SEO)" source="title_tc" fullWidth />
      </Grid>
      <Grid item sm={12} md={12}>
        <TextInput label="Page title in EN (SEO)" source="title_en" fullWidth />
      </Grid>

      <Grid item sm={12} md={12}>
        <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
      </Grid>

      <Grid item sm={12} md={12}>
        <RegionCheckboxGroupInput fullWidth />
      </Grid>

      <ShelfDateTimeInput />
    </Grid>
  );
};

const FetchEditorialData = (props) => {
  const dataProvider = useDataProvider();
  const form = useForm();

  // this is only for edit page first time load
  useEffect(async () => {
    if (!props.ref_x || props.ref_x.length == 0) {
      return;
    }

    var filterType = "";
    if (props.editorial_type_autocomplete) {
      filterType = props.editorial_type_autocomplete;
    } else if (props.ref_x && props.ref_x.split && props.ref_x.split("/") && props.ref_x.split("/")[1]) {
      filterType = props.ref_x.split("/")[1];
    }

    if (filterType) {
      const result = await dataProvider.getMpmRowScheduleTypeByType(filterType);

      if (result.data != null) {
        const editorial = result.data;
        form.change("editorial_name", editorial.name);
        form.change("editorial_type", editorial.type);
      }
    }
  }, []);

  useEffect(async () => {
    if (!props.editorial_type_autocomplete) {
      return;
    }

    // if (!props.ref_x || props.ref_x.length == 0) {
    //   return;
    // }

    var filterType = "";
    if (props.editorial_type_autocomplete) {
      filterType = props.editorial_type_autocomplete;
    } else {
      filterType = props.ref_x.split("/")[1];
    }

    const result = await dataProvider.getMpmRowScheduleTypeByType(filterType);

    if (result.data != null) {
      const editorial = result.data;
      form.change("editorial_name", editorial.name);
      form.change("editorial_type", editorial.type);
    }
  }, [props.editorial_type_autocomplete, props.ref_x]);

  return null;
};

export const RecommendationForm = ({ page }) => {
  const form = useForm();

  const record = useRecordContext();

  const isHomepage = (page && page.is_homepage) || (record.page && record.page.is_homepage);

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <SelectInput
          source="recommendation_type"
          choices={[
            { id: "recom_personalised", name: "Personalised" },
            { id: "recom_trendy", name: "Trending" },
            { id: "recom_universal", name: "Universal List" },
            { id: "recom_free_preview", name: "Free Episode" },
          ]}
          defaultValue=""
          fullWidth
          onChange={(e) => {
            if (e.target.value == "recom_trendy") {
              form.change("title_tc", "熱門節目");
              form.change("title_en", "Trending");
            } else if (e.target.value == "recom_personalised") {
              form.change("title_tc", "為你推薦");
              form.change("title_en", "Recommendation");
            } else if (e.target.value == "recom_free_preview") {
              form.change("title_tc", "為你推薦免費劇集");
              form.change("title_en", "Free Episode Recommendation");
            }
            // else if(e.target.value == 'universal_list') {
            //   form.change("title_tc", "為你推薦");
            //   form.change("title_en", "Recommendation");
            // }
          }}
        />
      </Grid>

      <FormDataConsumer label="Value" fullWidth>
        {({ formData, ...rest }) => {
          if (!formData.recommendation_type) {
            return <></>;
          }

          if (formData.recommendation_type == "recom_universal") {
            return (
              <Grid container spacing={1} fullWidth>
                <Grid item sm={12} md={12}>
                  {isHomepage ? <NumberInput fullWidth label="No. of list to show (Enter from 1-40)" source="num_of_rows" validate={[required(), minValue(1), maxValue(40)]} max={40} min={1} /> : <NumberInput fullWidth label="No. of list to show (Enter from 1-30)" source="num_of_rows" validate={[required(), minValue(1), maxValue(30)]} max={30} min={1} />}
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextInput label="Row title in TC" source="title_tc" fullWidth disabled defaultValue={"Follow the universal list"} />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextInput label="Row title in EN" source="title_en" fullWidth disabled defaultValue={"Follow the universal list"} />
                </Grid>

                <Grid item sm={12} md={12}>
                  <TemplateSelectInput layouts={["loop", "loop_portrait_to_landscape"]} defaultValue={"loop"} />
                </Grid>

                <Grid item sm={12} md={12}>
                  <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
                </Grid>
                <Grid item sm={12} md={12}>
                  <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
                </Grid>

                <Grid item sm={12} md={12}>
                  <TextInput label="Page title in TC (SEO)" source="title_tc" fullWidth />
                </Grid>
                <Grid item sm={12} md={12}>
                  <TextInput label="Page title in EN (SEO)" source="title_en" fullWidth />
                </Grid>

                <Grid item sm={12} md={12}>
                  <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
                </Grid>

                <Grid item sm={12} md={12}>
                  <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
                </Grid>

                <ShelfDateTimeInput />
              </Grid>
            );
          } else if (formData.recommendation_type == "recom_personalised") {
            return (
              <Grid container spacing={1} fullWidth>
                <Grid item sm={12} md={6}>
                  <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
                </Grid>
                <Grid item sm={12} md={12}>
                  <TemplateSelectInput layouts={["loop", "ranking", "loop_portrait_to_landscape"]} defaultValue={"loop"} />
                </Grid>

                <Grid item sm={12} md={12}>
                  <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
                </Grid>
                <Grid item sm={12} md={12}>
                  <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
                </Grid>

                <Grid item sm={12} md={12}>
                  <TextInput label="Page title in TC (SEO)" source="title_tc" fullWidth />
                </Grid>
                <Grid item sm={12} md={12}>
                  <TextInput label="Page title in EN (SEO)" source="title_en" fullWidth />
                </Grid>

                <Grid item sm={12} md={12}>
                  <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
                </Grid>

                <ShelfDateTimeInput />
              </Grid>
            );
          }

          return (
            <Grid container spacing={1} fullWidth>
              <Grid item sm={12} md={6}>
                <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
              </Grid>
              <Grid item sm={12} md={6}>
                <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
              </Grid>
              <Grid item sm={12} md={12}>
                <TemplateSelectInput layouts={["loop", "ranking"]} defaultValue={"loop"} />
              </Grid>

              <Grid item sm={12} md={12}>
                <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
              </Grid>
              <Grid item sm={12} md={12}>
                <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
              </Grid>

              <Grid item sm={12} md={12}>
                <TextInput label="Page title in TC (SEO)" source="title_tc" fullWidth />
              </Grid>
              <Grid item sm={12} md={12}>
                <TextInput label="Page title in EN (SEO)" source="title_en" fullWidth />
              </Grid>

              <Grid item sm={12} md={12}>
                <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
              </Grid>

              <ShelfDateTimeInput />
            </Grid>
          );
        }}
      </FormDataConsumer>
    </Grid>
  );
};

export const ProgrammeListForm = ({ rest, mode, page }) => {
  const dataProvider = useDataProvider();

  const [tagTypes, setTagTypes] = useState([]);

  useEffect(() => {
    dataProvider.getTagTypes().then((types) => {
      setTagTypes(types.data);
    });
  }, []);

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <ArrayInput source="tags">
          {/* Add TransitionProps because of bug: https://github.com/marmelab/react-admin/issues/6900 */}
          <SimpleFormIterator TransitionProps={{ enter: false, exit: false }}>
            {/* If want custom layout: https://stackoverflow.com/questions/60175609/arrayinput-with-simpleformiterator-of-react-admin-generate-wrong-output */}
            <SelectInput fullWidth source="tag_type" choices={tagTypes} label="Type" />
            <FormDataConsumer label="Value" fullWidth>
              {({ scopedFormData, getSource }) => {
                if (!scopedFormData) {
                  return <></>;
                }

                return (
                  <ReferenceInput
                    fullWidth
                    label="Value"
                    source={getSource("tag_value")}
                    reference="mpm-row-tag-autocomplete"
                    filter={{ tag_type: scopedFormData.tag_type }}
                    filterToQuery={(searchText) => {
                      if (searchText) {
                        return {
                          name_tc: searchText,
                        };
                      }
                      return {};
                    }}
                  >
                    <AutocompleteInput
                      fullWidth
                      optionText={(record) => {
                        if (record == null) {
                          return null;
                        }
                        return record.name_tc + " " + record.name_en;
                      }}
                    />
                  </ReferenceInput>
                );
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <BooleanInput label="Programmes with free episode only" source="free_episodes_only" defaultValue={false} fullWidth />
        </Grid>
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>

        <RowPathInput disabled={mode == "edit"} page={page ? page : null} />

        <Grid item sm={12} md={12}>
          <TemplateSelectInput layouts={["subcat", "multiline", "ranking", "loop_portrait_to_landscape"]} multilineNumOfColumns={[4, 5]} />
        </Grid>

        <Grid item sm={12} md={12}>
          <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
        </Grid>
        <Grid item sm={12} md={12}>
          <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
        </Grid>

        <Grid item sm={12} md={12}>
          <TextInput label="Page title in TC (SEO)" source="title_tc" fullWidth />
        </Grid>
        <Grid item sm={12} md={12}>
          <TextInput label="Page title in EN (SEO)" source="title_en" fullWidth />
        </Grid>

        {/* <FormDataConsumer>
            {({ formData, ...rest }) => {
              var subcatTemplate = templates.find((element) => element.layout == "subcat");
              if (subcatTemplate && formData.template == subcatTemplate.id) {
                return <BooleanInput label="Show it as item in menu tree" source="show_in_menu" />;
              }
              return <></>;
            }}
          </FormDataConsumer> */}

        <Grid item sm={12} md={12}>
          <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
        </Grid>

        <Grid item sm={12} md={12}>
          <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
        </Grid>

        <ShelfDateTimeInput />
      </Grid>
    </Grid>
  );
};

export const LatestForm = ({ rest }) => {
  const dataProvider = useDataProvider();

  const [tagTypes, setTagTypes] = useState([]);

  useEffect(() => {
    dataProvider.getTagTypes().then((types) => {
      setTagTypes(types.data);
    });
  }, []);

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <ArrayInput source="tags">
          {/* Add TransitionProps because of bug: https://github.com/marmelab/react-admin/issues/6900 */}
          <SimpleFormIterator TransitionProps={{ enter: false, exit: false }}>
            {/* If want custom layout: https://stackoverflow.com/questions/60175609/arrayinput-with-simpleformiterator-of-react-admin-generate-wrong-output */}
            <SelectInput fullWidth source="tag_type" choices={tagTypes} label="Type" />
            <FormDataConsumer label="Value" fullWidth>
              {({ scopedFormData, getSource }) => {
                if (!scopedFormData) {
                  return <></>;
                }

                return (
                  <ReferenceInput
                    fullWidth
                    label="Value"
                    source={getSource("tag_value")}
                    reference="mpm-row-tag-autocomplete"
                    filter={{ tag_type: scopedFormData.tag_type }}
                    filterToQuery={(searchText) => {
                      if (searchText) {
                        return {
                          name_tc: searchText,
                        };
                      }
                      return {};
                    }}
                  >
                    <AutocompleteInput
                      fullWidth
                      optionText={(record) => {
                        if (record == null) {
                          return null;
                        }
                        return record.name_tc + " " + record.name_en;
                      }}
                    />
                  </ReferenceInput>
                );
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
        </Grid>

        <Grid item sm={12} md={12}>
          <TemplateSelectInput layouts={["loop", "loop_portrait_to_landscape"]} defaultValue={"loop"} />
        </Grid>

        <Grid item sm={12} md={12}>
          <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
        </Grid>
        <Grid item sm={12} md={12}>
          <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
        </Grid>

        <Grid item sm={12} md={12}>
          <TextInput label="Page title in TC (SEO)" source="title_tc" fullWidth />
        </Grid>
        <Grid item sm={12} md={12}>
          <TextInput label="Page title in EN (SEO)" source="title_en" fullWidth />
        </Grid>

        <Grid item sm={12} md={12}>
          <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
        </Grid>

        <Grid item sm={12} md={12}>
          <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
        </Grid>

        <ShelfDateTimeInput />
      </Grid>
    </Grid>
  );
};

export const TopSVForm = ({ rest }) => {
  const dataProvider = useDataProvider();

  const [tagTypes, setTagTypes] = useState([]);

  useEffect(() => {
    dataProvider.getTagTypes().then((types) => {
      setTagTypes(types.data);
    });
  }, []);

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <ArrayInput source="tags">
          {/* Add TransitionProps because of bug: https://github.com/marmelab/react-admin/issues/6900 */}
          <SimpleFormIterator TransitionProps={{ enter: false, exit: false }}>
            {/* If want custom layout: https://stackoverflow.com/questions/60175609/arrayinput-with-simpleformiterator-of-react-admin-generate-wrong-output */}
            <SelectInput fullWidth source="tag_type" choices={tagTypes} label="Type" />
            <FormDataConsumer label="Value" fullWidth>
              {({ scopedFormData, getSource }) => {
                if (!scopedFormData) {
                  return <></>;
                }

                return (
                  <ReferenceInput
                    fullWidth
                    label="Value"
                    source={getSource("tag_value")}
                    reference="mpm-row-tag-autocomplete"
                    filter={{ tag_type: scopedFormData.tag_type }}
                    filterToQuery={(searchText) => {
                      if (searchText) {
                        return {
                          name_tc: searchText,
                        };
                      }
                      return {};
                    }}
                  >
                    <AutocompleteInput
                      fullWidth
                      optionText={(record) => {
                        if (record == null) {
                          return null;
                        }
                        return record.name_tc + " " + record.name_en;
                      }}
                    />
                  </ReferenceInput>
                );
              }}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
        </Grid>

        <Grid item sm={12} md={12}>
          <TemplateSelectInput layouts={["loop", "ranking"]} defaultValue={"loop"} />
        </Grid>

        <Grid item sm={12} md={12}>
          <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
        </Grid>
        <Grid item sm={12} md={12}>
          <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
        </Grid>

        <Grid item sm={12} md={12}>
          <TextInput label="Page title in TC (SEO)" source="title_tc" fullWidth />
        </Grid>
        <Grid item sm={12} md={12}>
          <TextInput label="Page title in EN (SEO)" source="title_en" fullWidth />
        </Grid>

        <Grid item sm={12} md={12}>
          <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
        </Grid>

        <Grid item sm={12} md={12}>
          <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
        </Grid>

        <ShelfDateTimeInput />
      </Grid>
    </Grid>
  );
};

export const WatchingHistoryForm = ({ rest }) => {
  return (
    <Grid container spacing={1} fullWidth>
      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth defaultValue="觀看紀錄" />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth defaultValue="Watching History" />
        </Grid>
      </Grid>

      <Grid item sm={12} md={12}>
        <TemplateSelectInput layouts={["history"]} defaultValue="history" />
      </Grid>

      <Grid item sm={12} md={12}>
        <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
      </Grid>

      <Grid item sm={12} md={12}>
        <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
      </Grid>

      <ShelfDateTimeInput />
    </Grid>
  );
};

export const EventForm = ({ formData, rest }) => {
  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <SelectEventType {...formData} />
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in TC" source="title_tc" validate={required()} fullWidth />
        </Grid>
        <Grid item sm={12} md={6}>
          <TextInput label="Row title in EN" source="title_en" validate={required()} fullWidth />
        </Grid>
      </Grid>

      <Grid item sm={12} md={12}>
        <TemplateSelectInput layouts={["loop", "multiline"]} multilineNumOfColumns={[4, 5]} isRequired={true} />
      </Grid>

      <Grid item sm={12} md={12}>
        <SeoDescriptionInput label="SEO Description in TC (within 85 char)" source="seo_desc_tc" maxLength={85} />
      </Grid>
      <Grid item sm={12} md={12}>
        <SeoDescriptionInput label="SEO Description in EN (within 170 char)" source="seo_desc_en" maxLength={170} />
      </Grid>

      <Grid item sm={12} md={12}>
        <TextInput label="Page title in TC (SEO)" source="title_tc" fullWidth />
      </Grid>
      <Grid item sm={12} md={12}>
        <TextInput label="Page title in EN (SEO)" source="title_en" fullWidth />
      </Grid>

      <Grid item sm={12} md={12}>
        <PlatformWithOrderCheckboxGroupInput fullWidth {...rest} />
      </Grid>

      <Grid item sm={12} md={12}>
        <RegionCheckboxGroupInput noDefaultValue={true} fullWidth />
      </Grid>

      <ShelfDateTimeInput />
    </Grid>
  );
};

const SelectEventType = (props) => {
  const dataProvider = useDataProvider();
  const [data, setData] = useState();

  var initialValue = "";
  if (props.ref_x && props.ref_x.split) {
    const event_type_value = props.ref_x.split("/")[1];
    initialValue = event_type_value;
  } else if (props.programme_id && props.programme_id.split) {
    const event_type_value = props.programme_id.split("/")[1];
    initialValue = event_type_value;
  }

  useEffect(() => {
    dataProvider
      .getListEventType()
      .then(({ data }) => {
        setData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  if (!data) return null;

  const keys = data[0].values.map((value) => ({
    id: value,
    name: value,
  }));
  return <SelectInput fullWidth source="event_type_value" initialValue={initialValue} choices={keys} allowEmpty={true} />;
};
